<template>
  <b-nav-item-dropdown id="dropdown-grouped" variant="link" class="trans">
    <template #button-content>
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
      <b-img
        :src="require('@/assets/global/translation.png')"
        height="22px"
        width="22px"
        :alt="currentLocale.locale"
      />
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="switchLocale(localeObj)"
      style="text-align: center"
    >
      <span>{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from "bootstrap-vue";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find((l) => l.locale === this.$i18n.locale);
    },
  },
  methods: {
    switchLocale(localeObj) {
      if (localeObj.locale !== this.$i18n.locale) {
        localStorage.setItem("lang", localeObj.locale);
        window.location.reload();
      }
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: "ar",
        img: "",
        name: "عربي",
      },
      {
        locale: "en",
        img: "",
        name: "English",
      },
    ];
    /* eslint-disable global-require */

    return {
      locales,
    };
  },
};
</script>

<style scoped>
.trans.dropdown-toggle::after {
  left: -7px;
}
</style>
